const data = {
  id: "landuse",
  title: "Land: Annexation, Zoning, & Development",
  intro: "Another development. Another rezoning. Another business relocating to Huntsville. It's not cheap here anymore — so why does the growth keep coming, who is actually paying for the infrastructure that follows, and why do some neighborhoods keep getting left out of the boom?",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      visual: { type: "placeholder", title: "Development map placeholder", description: "A development / annexation / incentive visual can live here in the rebuilt site." },
      issues: [],
      trail: [{ label: "Land-use data", text: "Existing annexation/development source data" }]
    },
    {
      id: "annexation",
      label: "Annexation",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "zoning",
      label: "Zoning",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "development",
      label: "Development",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
